<template>
    <div class="page">
        <div class="container">
            <div v-if="show">
                <div style="text-align: center;padding: 30px">
                    <h2>登记单位申请须知</h2>
                </div>
                <div class="contents">
                    <div class="never">
                        <div class="label-one">一、申请资格</div>
                        <div class="label-text">
                            <div>具有白血病诊疗能力的医疗机构</div>
                        </div>
                        <div class="label-one">二、申请账号</div>
                        <div class="label-text">
                            <div>请如实填写申请表，经过白血病登记系统技术组审核确认后，账号信息将在三个工作日内发送至申请邮箱，首次登陆后请修改密码。</div>
                        </div>
                        <div class="label-one">三、保密事项</div>
                        <div class="label-text">
                            <div>
                                1、 请贵单位保存好账号密码信息，如发现有任何账号被盗用的情况，请立即有效方式通知白血病登记系统技术组，申请账号保护相关服务。
                            </div>
                            <div>
                                2、不得以任何名义方式泄漏登记系统内患者的隐私相关信息。
                            </div>
                        </div>
                    </div>
                    <div class="contact">
                        <div>联系邮箱：rmslinc@163.com</div>
                        <div>联系座机：021-64370045-610718</div>
                    </div>
                    <div style="text-align: center">
                        <div style="padding: 20px">
                            <el-checkbox v-model="checked">我已阅读以上须知并准备填写</el-checkbox>
                        </div>
                        <el-button type="primary" :disabled="!checked" @click="handelShow">开始填写</el-button>
                        <el-button type=""  @click="goto">返 回</el-button>
                    </div>

                </div>
            </div>
            <el-card shadow="never" v-else style="  height: calc(100vh - 40px);overflow: auto">
                <div slot="header" class="clearfix">
                    <span>登记单位申请流程：</span>
                </div>
                <div class="steps">
                    <div class="step">
                        <img src="../assets/images/11.png" alt="">
                        <div class="line"></div>
                        <div>填写并提交申请单</div>
                    </div>
                    <div class="step">
                        <img src="../assets/images/12.jpg" alt="">
                        <div class="line"></div>
                        <div>等待登记系统技术组审核</div>
                    </div>
                    <div class="step">
                        <img src="../assets/images/13.png" alt="">
                        <div class="line"></div>
                        <div>查看邮箱接收账号</div>
                    </div>
                    <div class="step">
                        <img src="../assets/images/14.png" alt="">
                        <div class="line"></div>
                        <div>登录修改初始密码</div>
                    </div>
                    <div class="step">
                        <img src="../assets/images/15.png" alt="">
                        <div>开始数据上报工作</div>
                    </div>
                </div>
                <div class="contents">
                    <el-divider content-position="left" class="label">基本信息</el-divider>
                    <el-form :model="form"
                             label-width="120px"
                             ref="form"
                             size="small"
                             :rules="rules"
                             label-position="right"
                             class="form">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="医院机构名称" prop="mingcheng">
                                    <el-input v-model="form.mingcheng" placeholder="医院机构名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <!--                            <el-col :span="8">-->
                            <!--                                <el-button type="primary" plain>若下拉列表中不存在您的机构，请点此新增</el-button>-->
                            <!--                            </el-col>-->
                            <el-col :span="8">
                                <el-form-item label="医院机构简称" prop="jiancheng">
                                    <el-input v-model="form.jiancheng" placeholder="医院机构简称"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="医疗机构类别" prop="jigouleibie">
<!--                                    <el-input v-model="form.jigouleibie" placeholder="医疗机构类别"></el-input>-->
                                    <el-select v-model="form.jigouleibie" placeholder="请选择医疗机构类别"
                                               clearable filterable allow-create
                                               style="width: 100%">
                                        <el-option
                                                v-for="item in yllbList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="医疗机构等级" prop="jigoudengji">
<!--                                    <el-input v-model="form.jigoudengji" placeholder="医疗机构等级"></el-input>-->
                                    <el-select v-model="form.jigoudengji" placeholder="请选择医疗机构等级"
                                               clearable filterable allow-create
                                               style="width: 100%">
                                        <el-option
                                                v-for="item in jgdjList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="行政级别" prop="xingzhengjibie">
<!--                                    <el-input v-model="form.xingzhengjibie" placeholder="行政级别"></el-input>-->
                                    <el-select v-model="form.xingzhengjibie" placeholder="请选择行政级别"
                                               clearable filterable allow-create
                                               style="width: 100%">
                                        <el-option
                                                v-for="item in xzjbList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="医疗机构地址" prop="jigoudizhi">
                                    <el-cascader style="width: 100%;" v-model="form.jigoudizhi" :options="city"
                                                 filterable placeholder="请选择省市">
                                    </el-cascader>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="详细地址" prop="xiangxidizhi">
                                    <el-input v-model="form.xiangxidizhi" placeholder="详细地址"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="医保定点" prop="isyibao">
                                    <el-radio-group v-model="form.isyibao">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-divider content-position="left" class="label">项目负责人<span class="label-text">负责本机构整体上报工作，协调上报工作所需资源</span>
                        </el-divider>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="姓名" prop="fzrxm">
                                    <el-input v-model="form.fzrxm" placeholder="姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="所在科室" prop="fzrks">
                                    <el-input v-model="form.fzrks" placeholder="所在科室"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系邮件" prop="fzryj">
                                    <el-input v-model="form.fzryj" placeholder="联系邮件"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-divider content-position="left" class="label">数据录入员<span
                                class="label-text">负责本机构病例数据信息补充工作</span></el-divider>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="姓名" prop="lrxm">
                                    <el-input v-model="form.lrxm" placeholder="姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="所在科室" prop="lrks">
                                    <el-input v-model="form.lrks" placeholder="所在科室"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系邮件" prop="lryj">
                                    <el-input v-model="form.lryj" placeholder="联系邮件"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="contact">
                        <div>联系邮箱：rmslinc@163.com</div>
                        <div>联系座机：021-64370045-610718</div>
                    </div>
                    <div style="text-align: center">
                        <el-button @click="reset">重 置</el-button>
                        <el-button type="primary" @click="onSubmit">提 交</el-button>
                        <el-button @click="goto">返 回</el-button>
                        <el-button @click="show=true">上一步</el-button>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import * as table from '../config/cyit'

    const makeInitSearch = () => {
        return {
            lryj: '',
            lrks: '',
            lrxm: '',
            fzryj: '',
            fzrks: '',
            fzrxm: '',
            isyibao: '',
            xiangxidizhi: '',
            jigoudizhi: '',
            xingzhengjibie: '',
            jigoudengji: '',
            jigouleibie: '',
            jiancheng: '',
            mingcheng: ''
        }
    }
    export default {
        data() {
            return {
                checked: false,
                show: true,
                city: table.citys,
                form: makeInitSearch(),
                rules: {
                    mingcheng: [
                        {required: true, message: '请输入医院机构名称', trigger: 'blur'},
                    ],
                    jiancheng: [
                        {required: true, message: '请输入医院机构简称', trigger: 'blur'},
                    ],
                    jigouleibie: [
                        {required: true, message: '请输入医疗机构类别', trigger: 'blur'},
                    ],
                    jigoudengji: [
                        {required: true, message: '请输入医疗机构等级', trigger: 'blur'},
                    ],
                    xingzhengjibie: [
                        {required: true, message: '请输入行政级别', trigger: 'blur'},
                    ],
                    jigoudizhi: [
                        {required: true, message: '请输入医疗机构地址', trigger: 'blur'},
                    ],
                    xiangxidizhi: [
                        {required: true, message: '请输入详细地址', trigger: 'blur'},
                    ],
                    isyibao: [
                        {required: true, message: '请选择医保定点', trigger: 'blur'},
                    ],
                    fzrxm: [
                        {required: true, message: '请输入负责人名称', trigger: 'blur'},
                    ],
                    fzrks: [
                        {required: true, message: '请输入负责人科室', trigger: 'blur'},
                    ],
                    fzryj: [
                        {required: true, message: '请输入负责人邮件', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
                    ],
                    lrxm: [
                        {required: true, message: '请输入录入员名称', trigger: 'blur'},
                    ],
                    lrks: [
                        {required: true, message: '请输入录入员科室', trigger: 'blur'},
                    ],
                    lryj: [
                        {required: true, message: '请输入录入员邮件', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
                    ]
                },
                yllbList:[
                    {value:"综合医院",label:"综合医院"},
                    {value:"中医医院",label:"中医医院"},
                    {value:"中西医结合医院",label:"中西医结合医院"},
                    {value:"民族医医院",label:"民族医医院"},
                    {value:"专科医院",label:"专科医院"},
                    {value:"康复医院",label:"康复医院"},
                    {value:"妇幼保健院",label:"妇幼保健院"},
                    {value:"妇幼保健计划生育服务中心",label:"妇幼保健计划生育服务中心"},
                    {value:"社区卫生服务中心",label:"社区卫生服务中心"},
                    {value:"社区卫生服务站",label:"社区卫生服务站"},
                    {value:"中心卫生院",label:"中心卫生院"},
                    {value:"乡(镇)卫生院",label:"乡(镇)卫生院"},
                    {value:"街道卫生院",label:"街道卫生院"},
                    {value:"疗养院",label:"疗养院"},
                    {value:"综合门诊部",label:"综合门诊部"},
                    {value:"专科门诊部",label:"专科门诊部"},
                    {value:"中医门诊部",label:"中医门诊部"},
                    {value:"中西医结合门诊部",label:"中西医结合门诊部"},
                    {value:"民族医门诊部",label:"民族医门诊部"},
                    {value:"诊所",label:"诊所"},
                    {value:"中医诊所",label:"中医诊所"},
                    {value:"民族医诊所",label:"民族医诊所"},
                    {value:"卫生所",label:"卫生所"},
                    {value:"医务室",label:"医务室"},
                    {value:"卫生保健所",label:"卫生保健所"},
                    {value:"卫生站",label:"卫生站"},
                    {value:"村卫生室（所）",label:"村卫生室（所）"},
                    {value:"急救中心",label:"急救中心"},
                    {value:"急救站",label:"急救站"},
                    {value:"临床检验中心",label:"临床检验中心"},
                    {value:"专科疾病防治院",label:"专科疾病防治院"},
                    {value:"专科疾病防治所",label:"专科疾病防治所"},
                    {value:"专科疾病防治站",label:"专科疾病防治站"},
                    {value:"护理院",label:"护理院"},
                    {value:"护理站",label:"护理站"},
                    {value:"医学检验实验室",label:"医学检验实验室"},
                    {value:"病理诊断中心",label:"病理诊断中心"},
                    {value:"医学影像诊断中心",label:"医学影像诊断中心"},
                    {value:"血液透析中心",label:"血液透析中心"},
                    {value:"安宁疗护中心",label:"安宁疗护中心"},
                ],
                jgdjList:[
                    {value:"一级甲等",label:"一级甲等"},
                    {value:"二级甲等",label:"二级甲等"},
                    {value:"三级甲等",label:"三级甲等"},
                    {value:"一级乙等",label:"一级乙等"},
                    {value:"二级乙等",label:"二级乙等"},
                    {value:"三级乙等",label:"三级乙等"},
                    {value:"一级丙等",label:"一级丙等"},
                    {value:"二级丙等",label:"二级丙等"},
                    {value:"三级丙等",label:"三级丙等"},
                    {value:"一级未分等",label:"一级未分等"},
                    {value:"二级未分等",label:"二级未分等"},
                    {value:"三级未分等",label:"三级未分等"},

                ],
                xzjbList:[
                    {value:"国家级",label:"国家级"},
                    {value:"省级",label:"省级"},
                    {value:"市级",label:"市级"},
                    {value:"县级",label:"县级"}
                ]
            };
        },
        methods: {
            goto(){
                this.$router.push({ path: '/login' })
            },
            reset() {
                this.form = makeInitSearch()
            },
            handelShow() {
                this.show = false
            },
            onSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$http.post('/register/institution/', this.form)
                            .then(resp => {
                                    if (resp.data.code == 1) {
                                        this.$message({
                                            message: '申请成功！',
                                            type: 'success'
                                        })
                                        this.$router.push({ path: '/login' })
                                    } else if (resp.data.code == -1) {
                                        this.$message({
                                            message: `${this.form.mingcheng} 已注册！`,
                                            type: 'error'
                                        })
                                    }
                                }
                            )
                    }
                })
            },
        }
    };
</script>

<style scoped>

    .steps {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        justify-content: center;
    }

    /*.step {*/
    /*    width: 20%;*/
    /*}*/

    .step img {
        width: 40px;
        /*height: 50px;*/
        margin-bottom: 10px;
        display: flex;
        z-index: 999;
        /*position: absolute;*/
    }

    .step div {
        font-size: 13px;
    }

    .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: left;
        width: 20%;
        position: relative;
    }

    .line {
        width: 80%;
        height: 2px;
        background-color: #3498db;
        position: absolute;
        left: 60%;
        top: 30%;
    }


    .page {
        background: linear-gradient(#e6f2ff, #ffffff);
        height: 100vh;
    }

    .container {
        width: 70%;
        margin: 0 auto;
        padding-top: 20px;
    }


    .contents {
        font-size: 16px;
        line-height: 1.6;
    }

    .never {
        background-color: white;
        border: 1px solid #e6f2ff;
        padding: 20px;
        border-radius: 10px;
    }

    .contact {
        text-align: right;
        font-size: 15px;
        margin-top: 20px;
        line-height: 30px;
    }

    .label {
        position: relative
    }

    .label::before {
        content: '';
        height: 14px;
        width: 3px;
        background: #1989fa;
        position: absolute;
        left: 10px;
        top: calc(50% - 7px);
        z-index: 999
    }

    ::v-deep .el-divider__text.is-left {
        left: 0px !important;
        font-size: 15px;
        font-weight: bold !important;
    }

    .label .label-text {
        color: #3a8ee6;
        padding: 10px;
        font-weight: 500 !important;
        font-size: 13px;
    }

    .never .label-text {
        font-size: 14px;
        line-height: 30px;
        text-indent: 2em; /* 使用em单位 */
    }
</style>
